export default {
  title: 'Transfer Website',
  buttons: {
    cancel: 'Cancel',
    transfer: 'Transfer',
  },
  fields: {
    target_franchise: {
      label: 'Target Franchise',
      description: 'Select the franchise to transfer the website to',
    },
    sync_companies: {
      label: 'Company Mappings',
      description: 'Map companies from the target franchise to storefront companies',
      franchise_company: 'Franchise Company',
      storefront_company: 'Storefront Company',
      select_franchise_company: 'Select franchise company',
      select_storefront_company: 'Select storefront company',
      franchise_company_required: 'Franchise company is required',
      storefront_company_required: 'Storefront company is required',
    },
  },
  toasts: {
    failed_to_load_companies: 'Failed to load companies',
    no_companies_selected: 'Please add at least one company mapping',
    failed_to_transfer: 'Failed to transfer website',
    transfer_success: 'Website transferred successfully',
    franchise_already_connected: 'Target Franchise is already connected to a website',
  },
};
